import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  notifyPromise,
} from "../../../Utils/Helper";
import {
  ngeniusDepositSuccess,
  ngeniusDepositFailure,
} from "../../Action/ngenius/ngeniusDepositAction";
import { NGENIUS_DEPOSIT } from "../../Action/actionTypes";

function* ngeniusDepositRequest(action) {
  try {
    const { data } = yield notifyPromise(
      API.post(`/ngeniusdeposit`, action?.payload?.payload)
    );

    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }

    if (data?.meta?.code === 200) {
      yield put(ngeniusDepositSuccess(data?.data));
    } else {
      yield put(ngeniusDepositFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(ngeniusDepositFailure());
  }
}

export function* watchNGeniusDepositAPI() {
  yield takeEvery(NGENIUS_DEPOSIT, ngeniusDepositRequest);
}

export default function* rootSaga() {
  yield all([watchNGeniusDepositAPI()]);
}
